
import { Component, Vue } from "vue-property-decorator";
import { RankingList, StatisticalData, deviceStatus } from "@/views/components";
import deviceItem from "@/views/components/DeviceStatus/deviceItem";
import YtoTable from "@/views/components/YtoTable/TtoTable.vue";
import Scan2 from "@/views/components/Scan/Scan2.vue";
import config from "./config";
import Form1 from "./Form1.vue";
import DeviceItems2 from "@/views/components/DeviceStatus/DeviceItems2.vue";
import RankingList2 from "@/views/components/RankingList/RankingList2.vue";
import { ScanforSixScanModule } from "@/store/modules/store_scanforsixscan";
import {
  ApiQueryType,
  OpCodeEnum,
  SendDataType,
  ReceiveDataType,
  ErrorCode,
} from "@/common/glboalconstant";
import { LogHelper } from "@/common/LogHelper";
import { playLayerVioce, FloorVoiceInit } from "@/common/voiceLayer";
import dayjs from "dayjs";
import {
  checkCodesAndType, clientOptLog, cloudPress,
  modeNew,
  // checklineFrequencys,
} from "@/api/service";
import {
  playFailSound,
  playSuccessSound,
  playWantedPackSound,
} from "@/common/voiceTip";
import { DeviceItems2Module } from "@/store/modules/store_deviceitems2";
import { SystemConfigModule } from "@/store/modules/store_systemconfig";
import { InterceptUtils } from "@/common/intercept-utils";
import {BizUtil} from "@/utils/biz-util";

@Component({
  name: "scanforsixscannew",
  components: {
    deviceStatus,
    RankingList,
    StatisticalData,
    YtoTable,
    Form1,
    Scan2,
    DeviceItems2,
    RankingList2,
  },
})
export default class extends Vue {
  private inputModel: inputDataModel_SixScan = {
    checked_NeedWeight: true,
    checked_NeedVolumn: false,
    input_ScanCode: "",
    input_TrueThingCode: "",
  };
  public loginData: any = {};
  public globalConfig: any = {};
  public systemConfig: any = {};
  public DataQueue = [];
  private timer;
  private ws: WebSocket = null;

  mounted() {
    //初始化统计数据栏目内显示的数据
    this.statisticalList = [{ label: "总扫描数", value: "0", combine: "1" }];

    try {
      //注册设备状态回调函数
      this.globalConfig = SystemConfigModule.globalData;
      this.systemConfig = SystemConfigModule.systemData;
      this.loginData = SystemConfigModule.loginData;
      if (typeof obj_DWS_Core !== "undefined") {
        obj_DWS_Core.registerJavaScriptCallback(
          "DWSReceiveDataSetPackageData",
          (value) => {
            console.log("DWS传输过来的参数");
            console.log(value);
            this.ReceiveDataEvent(JSON.parse(value));
          }
        );
      }
      FloorVoiceInit();

      obj_ScanForSixScan.regist_statisticaldata(this.statisticaldatacallback);
      obj_ScanForSixScan.regist_errormsgcallback(this.errormsgcallback);

      if (obj_ScanForSixScan.regist_setnewcount){
        obj_ScanForSixScan.regist_setnewcount(this.setnewcount);
      }

      console.log("kuanglingmin 202301105-1430");
      this.ws = new WebSocket(`ws://localhost:40989/`);
      var _this = this;
      this.ws.onopen = () => {
        console.log('opened dws task ws')
      };
      this.ws.onmessage = function (e) {
        if (!e.data) {
          return;
        }
        console.log("VUE收到数据:" + e.data);
        LogHelper.WriteLog("收到数据: "+dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"));

        var obj = JSON.parse(e.data);
        if (obj.ActionName === 'CodeReaderSetPackageData') {
          var data = JSON.parse(obj.Parameter);
          _this.CodeReaderSetPackageData(data);
        }
      }


      setTimeout(() => {
        obj_ScanForSixScan.vueLoaded();
      }, 500);
    } catch (error) {
      console.log("六面扫描界面:注册回调函数异常" + error);
    }
    var el = document.getElementById("input_scancode_id");
    this.selectElementContents(el);

    //新增上传落格回传上车数据处理线程,add by klm 20220909
    this.timer = setInterval(() => {
      if (this.DataQueue.length)
      {
        try {
          this.DropLatticeDataUpload();
        } catch (error) {
          console.log("error");
          console.log(error);
        }
      }
    }, 50);
  }

  public  CodeReaderSetPackageData(value)
  {
    var temp = JSON.parse(value);
    switch (temp.ReceiveDataType)
    {
      case ReceiveDataType.CameraState:
        // deviceStateControl1.RefreshState(new JavaScriptSerializer().Deserialize<Camera_State>(receiveDataEventArgs.JsonData.ToString()));
        this.SetCameraState(
          JSON.parse(temp.JsonData.toString())
        );
        break;
      case ReceiveDataType.CodeUpload:
        this.setPackageData(JSON.parse(temp.JsonData.toString()));
        break;
      case ReceiveDataType.SixScanData:
        this.InsertDataToList2(value);
          break
      case ReceiveDataType.DropLatticeData:
        this.defaultStatusInfo = "未上传";
        //六面扫上车数据异步上传,add by klm 20220909
        var data = JSON.parse(temp.JsonData.toString());
        var threeCode = data.threeCode||"";
        if (!threeCode){
          for (var i = 0; i < this.latticeThreeCodeList.length; i++) {
            if (this.latticeThreeCodeList[i].strCode == data.code) {
              threeCode = this.latticeThreeCodeList[i].Extend5ThreeCode;
              console.log(data.code+":"+ threeCode);
              this.latticeThreeCodeList.splice(i, 1);
              break;
            }
          }
        }


        //this.DropLatticeDataUploadNew(data.code,data.latticeNo,threeCode);
        if (data.code.indexOf('-')>0){
          let codes = data.code.split('-');
          for (let i = 0; i < codes.length; i++) {
            this.DataQueue.unshift({
              wayBillNo: codes[i],
              createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
              latticeNo: data.latticeNo,
              latticeThreeCode:threeCode,
              data:data
            });
          }
        }
        else{
          this.DataQueue.unshift({
            wayBillNo: data.code,
            createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
            latticeNo: data.latticeNo,
            latticeThreeCode:threeCode,
            data:data
          });
        }
        // while (this.latticeThreeCodeList.length > 100) this.latticeThreeCodeList.pop();


        break;
    }
  }


  public InsertDataToList2 (data)
  {
    var temp = JSON.parse(data.toString())
    if (
      this.m_OutBound_SixScan_DataList.some(
        (t) => t.strCode == temp.strCode
      )
    ) {
      playFailSound();
      this.errormessage = "重复扫描";
    } else {
      //无读
      if (temp.strCode == "NOREAD")
      {
        this.errormessage = "NOREAD";
        this.noReadNum++;
        ScanforSixScanModule.setNoReadLablel(this.noReadNum);
      }
      //多条码
      else if (temp.strCode.indexOf("-") != -1) {
        this.manyCodeNum++;
        ScanforSixScanModule.setManyCodeLabel(this.manyCodeNum);
      }//有格口
      else if(temp.latticeNo == null || temp.latticeNo == "")
      {
        this.noLittleNum++;
        ScanforSixScanModule.setNoLittleNoLabel(this.noLittleNum);
      }
      else
      {
        this.littleNum++;
        ScanforSixScanModule.setLittleNoLabel(this.littleNum);
      }
      this.nTotalScanNum++;

      if (ScanforSixScanModule.newSixScanInterface)
      {
        var codeRate = 1 - this.noReadNum / this.nTotalScanNum;
        var ret = (codeRate * 100).toFixed(2) + '%';
        ScanforSixScanModule.setOverTimeLabel(ret);
      }



      this.statisticalList[0].value = this.nTotalScanNum.toString();
      this.InsertDataToList({
        LatticeNo: temp.latticeNo,
        ThreeCode: temp.threeCode,
        Extend5ThreeCode: temp.extend5ThreeCode,
        strCode: temp.strCode,
        ScanTime: temp.createTime,
      });

      if (temp.strCode == "NOREAD" || temp.strCode.indexOf("-") != -1)
      {
        console.log("noread osd");
      }
      else
      {
        obj_Camera_Core.cameraBLLEnqueueFacade(
          temp.strCode,
          OpCodeEnum.debus.toString(),
          this.loginData.employeeName,
          null,
          "六面扫"
        );
        console.log("osd入列：" + temp.strCode);
      }

      LogHelper.WriteLog(
        "无读件：" +
        this.noReadNum.toString() +
        ";  无格口件:" +
        this.noLittleNum.toString() +
        ";   多条码件：" +
        this.manyCodeNum.toString() +
        ";   超时，无格口件:" +
        this.overTimeNum.toString() +
        ";   有格口件:" +
        this.littleNum.toString()
      );
    }
  }

  //新增落格数据回传接口，add by klm 20220909
  public async DropLatticeDataUpload()
  {
    try {
      if (this.DataQueue.length > 0){
        debugger
        let data = this.DataQueue.pop();
        let signsure = obj_HttpRequest_Core.getSignature("8624", data.createTime);
        let _request = {
          mty: "8624",
          signature: signsure,//登录时需要获取的签名
          createTime: data.createTime,
          createUserCode: this.loginData.userCode,
          createUserName: this.loginData.userName,
          createOrgCode: this.loginData.orgCode,
          createOrgName: this.loginData.orgName,
          channel: "CV-PC",
          deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
          deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
          waybillNo: data.wayBillNo,
          latticeNo: data.latticeNo,
          latticeThreeCode:data.latticeThreeCode,
          cartNo: BizUtil.getCarNo(data.data),
          extend2: data.data.LATTICE_FLAG,
          schemeId: data.data.schemeId
        };
        let stReturnStr = JSON.parse(cloudPress(JSON.stringify(_request)));
        (clientOptLog([data.wayBillNo],[data.latticeNo,data.latticeThreeCode,_request.deviceNo,_request.deviceType],'8053'));
        let ret = false;
        if (stReturnStr?.code == "000")
        {
          ret = true;
        }
        else
        {
          ret = false;
        }
        //更新状态及线路、下一网点信息
        for (var i = 0; i < this.showList.length; i++) {
          if (this.showList[i].strCode == data?.wayBillNo) {

            this.showList[i].LineName = stReturnStr?.data.lineName;
            this.showList[i].NextOrgCode = stReturnStr?.data.nextOrgName;
            if (ret)
            {
              this.showList[i].state = "上传成功";

            }
            else
            {
              this.showList[i].state = "上传失败";
              this.showList[i].Info = stReturnStr.msg;
            }
            break;
          }
        }
      }
    }
    catch (e) {

    }
  }


  //新增落格数据回传接口，add by klm 20220909
  public async DropLatticeDataUploadNew(wayBillNo,latticeNo,latticeThreeCode)
  {
    try {
        let createTime = dayjs().format("YYYY-MM-DD HH:mm:ss.SSS");
        let signsure = obj_HttpRequest_Core.getSignature("8624", createTime);
        let _request = {
          mty: "8624",
          signature: signsure,//登录时需要获取的签名
          createTime: createTime,
          createUserCode: this.loginData.userCode,
          createUserName: this.loginData.userName,
          createOrgCode: this.loginData.orgCode,
          createOrgName: this.loginData.orgName,
          channel: "CV-PC",
          deviceNo: this.globalConfig.LocalIPv4,//大写,用冒号分隔，必填
          deviceType: this.globalConfig.CurrentDeviceType.toString(),//设备类型，必填
          waybillNo: wayBillNo,
          latticeNo: latticeNo,
          latticeThreeCode:latticeThreeCode,
          // cartNo: getCarNo(data),
        };
        let stReturnStr =  JSON.parse(cloudPress(JSON.stringify(_request)));
        let ret = false;
        if (stReturnStr?.code == "000")
        {
          ret = true;
        }
        else
        {
          ret = false;
        }
        //更新状态及线路、下一网点信息
        for (var i = 0; i < this.showList.length; i++) {
          if (this.showList[i].strCode == wayBillNo) {

            this.showList[i].LineName = stReturnStr?.data.lineName;
            this.showList[i].NextOrgCode = stReturnStr?.data.nextOrgName;
            if (ret)
            {
              this.showList[i].state = "上传成功";

            }
            else
            {
              this.showList[i].state = "上传失败";
              this.showList[i].Info = stReturnStr.msg;
            }
            break;
          }
        }

    }
    catch (e) {

    }
  }

  public ReceiveDataEvent(receiveDataEventArgs) {
    switch (receiveDataEventArgs.ReceiveDataType) {
      case ReceiveDataType.CameraState:
        // deviceStateControl1.RefreshState(new JavaScriptSerializer().Deserialize<Camera_State>(receiveDataEventArgs.JsonData.ToString()));
        this.SetCameraState(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );
        break;
        break;
      case ReceiveDataType.CodeUpload:
        this.setPackageData(
          JSON.parse(receiveDataEventArgs.JsonData.toString())
        );
        break;
      case ReceiveDataType.CodeCheck:
        //SetCodeCheck(new JavaScriptSerializer().Deserialize<CodeCheck_Data>(receiveDataEventArgs.JsonData.ToString()));
        break;
      case ReceiveDataType.ErrorState:
        this.SetErrorCode(JSON.parse(receiveDataEventArgs.JsonData.toString()));
        break;
      case ReceiveDataType.ErrorInfo:
        this.SetErrorInfo(JSON.parse(receiveDataEventArgs.JsonData.toString()));
        break;
      ///陆海晶 2019年4月18日10:32:12
      case ReceiveDataType.KillFocusDll:
        //SetKillFocus(new JavaScriptSerializer().Deserialize<KillFocus_Data>(receiveDataEventArgs.JsonData.ToString()));
        break;
      case ReceiveDataType.DropLatticeData:
        this.defaultStatusInfo = "未上传";
        //六面扫上车数据异步上传,add by klm 20220909
        var data = JSON.parse(receiveDataEventArgs.JsonData.toString());
        var threeCode = "";
        for (var i = 0; i < this.showList.length; i++) {
          if (this.showList[i].strCode == data.code) {
            threeCode = this.showList[i].Extend5ThreeCode;
            break;
          }
        }
        this.DataQueue.unshift({
          wayBillNo: data.code,
          createTime: dayjs().format("YYYY-MM-DD HH:mm:ss.SSS"),
          latticeNo: data.latticeNo,
          latticeThreeCode:threeCode,
          data: data
        });
        break;
    }
  }

  //DWS设置相机状态
  private SetCameraState(strCameraState) {
    let items = this.RefreshState(strCameraState);
    DeviceItems2Module.SetDeviceItemsState(items);
    return;
  }

  //DWS刷新设备状态信息
  private RefreshState(camera_State) {
    let result = [];
    for (let i = 1; i <= camera_State.cameraState.camList.length; i++) {
      let _info =
        "" +
        "设备" +
        i.toString() +
        "-" +
        "设备状态:" +
        camera_State.cameraState.camList[i - 1].camStatus +
        "-" +
        "设备模式:" +
        this.IsNullorEmptyorUndefined(
          camera_State.cameraState.camList[i - 1].camModel
        )
          ? ""
          : camera_State.cameraState.camList[i - 1].camModel +
            "-" +
            //$"是否有值:是-" +
            "设备Mac:" +
            camera_State.cameraState.camList[i - 1].camMac;

      result.push({
        title: _info,
        name: "设备" + i,
        status:
          camera_State.cameraState.camList[i - 1].camStatus == "1"
            ? "true"
            : "false",
      });
    }

    return result;
  }
  public SetErrorInfo(stErrorInfo) {
    LogHelper.WriteLog(
      "ScanGetOff_HKDeviceErrorInfo: " + JSON.stringify(stErrorInfo)
    );
    this.errormessage = stErrorInfo.ErrorString;
  }
  private m_bNoNesseryMsg = false;
  private m_bNeedSuppleCode = false;
  private isThroughMode = false; //是否是只直通模式
  private isExceptionStatus = false; //是否是异常情况，比如体积异常、重量异常的情况，保证提示信息的有效性
  private  defaultStatusInfo = "--";
  public SetErrorCode(IntErrorCode) {
    if (this.m_bNoNesseryMsg) return false;
    switch (parseInt(IntErrorCode.errorCode)) {
      case ErrorCode.NeedSuppleCode:
        this.errormessage = "需要补码";
        this.m_bNeedSuppleCode = true;

        //tbx_scanArea.Focus();
        break;
      case ErrorCode.TooMuchCode:
        this.errormessage = "多条码";
        if (this.isThroughMode) {
        } else {
          this.m_bNeedSuppleCode = true;
        }
        break;
      case ErrorCode.NoWeight:
        this.errormessage = "无重量";
        this.isExceptionStatus = true;

        break;
      case ErrorCode.OverWeight:
        this.errormessage = "超重";
        this.isExceptionStatus = true;

        break;
      case ErrorCode.NoVolumn:
        this.errormessage = "无体积";
        this.isExceptionStatus = true;

        break;
      case ErrorCode.TooLong:
        this.errormessage = "体积超长";
        this.isExceptionStatus = true;

        break;
      case ErrorCode.NoEntry:
        this.errormessage = "超时，包裹不准入";
        this.isExceptionStatus = true;

        break;
      case ErrorCode.ClearState:
        this.errormessage = "";
        this.m_bNeedSuppleCode = false;
        this.isExceptionStatus = false;

        break;
      case ErrorCode.Reset:
        this.errormessage = "";
        this.m_bNeedSuppleCode = false;
        this.isExceptionStatus = false;

        break;
      default:
        break;
    }

    return true;
  }
  public latticeNo = "";
  public noReadNum = 0 /*无读件*/;
  public noLittleNum = 0 /*无格口件*/;
  public littleNum = 0 /*有格口件*/;
  public manyCodeNum = 0 /*多条码件*/;
  public overTimeNum = 0; //超时，无格口件
  public threeCode = "";
  public extend5ThreeCode = "";
  private m_OutBound_SixScan_DataList = [];

  public jgCode = new RegExp("^JG(\d{9})(\d{2})$");

  public async setPackageData(stPackageData) {
    this.latticeNo = "";
    LogHelper.WriteLog("ScanGetOff_GetHKInfo;" + JSON.stringify(stPackageData));
    this.errormessage = "";
    //原本读取code地字段，现在如果code没有数据，读取Code字段代替
    if (
      stPackageData.code == null ||
      stPackageData.code == undefined ||
      stPackageData.code == ""
    ) {
      if (
        stPackageData.Code != null &&
        stPackageData.Code != undefined &&
        stPackageData.Code.length > 0
      ) {
        stPackageData.code = stPackageData.Code;
        console.log("setPackageData1:" + stPackageData.code);
      }
    }
    stPackageData.code = stPackageData.code.toUpperCase().trim();
    if (
      stPackageData.code != null &&
      stPackageData.code.length > 0 &&
      stPackageData.code == "NOREAD"
    ) {
      this.errormessage = "NOREAD";
      this.noReadNum++;
      ScanforSixScanModule.setNoReadLablel(this.noReadNum);
      playLayerVioce("8");
      if (typeof VoiceLayerHelper !== "undefined") {
        VoiceLayerHelper.onPlaySoundFloor("8");
      }
      this.InsertData(stPackageData.code);
      return false;
    }
    //if (stPackageData.code.Substring(0, 2).toUpperCase() == "CQ")
    if (stPackageData.code.indexOf("-") != -1) {
      this.manyCodeNum++;
      ScanforSixScanModule.setManyCodeLabel(this.manyCodeNum);
      this.InsertData(stPackageData.code);
      return false;
    }
    // var rg = checkCodesAndType(stPackageData.code.Split());
    var rg = JSON.parse(checkCodesAndType(stPackageData.code.split()));
    if (rg.ResultCode == "200" && rg.Type == ApiQueryType.strCarCode) {
      LogHelper.WriteLog("扫到车签，过滤");
      return false;
    }
    obj_Camera_Core.cameraBLLEnqueueFacade(
      stPackageData.code,
      OpCodeEnum.debus.toString(),
      this.loginData.employeeName,
      null,
      "六面扫"
    );

    // tbx_scanArea.Text = stPackageData.code;
    // tbx_scanArea.Focus();
    // tbx_scanArea.SelectAll();
    //如果是JG开头的单号
    if (this.jgCode.test(stPackageData.code))
    {
      this.latticeNo = stPackageData.code.substring(10,stPackageData.code.length);
        //给底层发格口信息
      // HKSocket.SynSendDataCallBack(SendDataType.PortData,
      //     dwsQueryResponseNew.data?.WAYBILL_NO + "|" + dwsQueryResponseNew.data?.LATTICE_NO + "|" + dwsQueryResponseNew.data.EXTEND5);
      obj_DWS_Core.hKSocketSynSendDataCallBack(
        SendDataType.PortData,
        stPackageData.code +
        "|" +
        this.latticeNo+
        "|" +
        "375"
      );
    }
    else
    {
      if (!this.SetCodeCheck(stPackageData.code)) {
        return false;
      }
    }

    if (
      this.m_OutBound_SixScan_DataList.some(
        (t) => t.strCode == stPackageData.code
      )
    ) {
      playFailSound();
      this.errormessage = "重复扫描";
    } else {
      this.nTotalScanNum++;
      this.statisticalList[0].value = this.nTotalScanNum.toString();
      this.InsertDataToList({
        LatticeNo: this.latticeNo,
        ThreeCode: this.threeCode,
        Extend5ThreeCode: this.extend5ThreeCode,
        strCode: stPackageData.code,
        ScanTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
      });

      LogHelper.WriteLog(
        "无读件：" +
          this.noReadNum.toString() +
          ";  无格口件:" +
          this.noLittleNum.toString() +
          ";   多条码件：" +
          this.manyCodeNum.toString() +
          ";   超时，无格口件:" +
          this.overTimeNum.toString() +
          ";   有格口件:" +
          this.littleNum.toString()
      );
      playSuccessSound();
      ScanforSixScanModule.setTrueThingCode("");
      // // tbx_scanArea.Text = "";
    }
    return true;
  }
  private nTotalScanNum = 0;

  public InsertData(code) {
    this.nTotalScanNum++;
    this.statisticalList[0].value = this.nTotalScanNum.toString();
    this.InsertDataToList({
      LatticeNo: "",
      ThreeCode: "",
      strCode: code,
      ScanTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
    });
    // // tbx_scanArea.Text = "";
    ScanforSixScanModule.setTrueThingCode("");
  }

  public InsertDataToList(package_DataByQueue) {
    package_DataByQueue.index = this.index;
    this.index++;
    package_DataByQueue.LineName = "";
    package_DataByQueue.NextOrgCode ="";
    package_DataByQueue.Info = "";
    package_DataByQueue.state = this.defaultStatusInfo;
    this.latticeThreeCodeList.push({
      strCode:package_DataByQueue.strCode,
      Extend5ThreeCode:package_DataByQueue.Extend5ThreeCode
    });

    this.showList.unshift(package_DataByQueue);
    while (this.showList.length > 50) this.showList.pop();


    // // if (DataHistory.Count > 0)
    // // {
    // //     dataGridView1.Rows[0].Selected = true;
    // //     dataGridView1.CurrentCell = dataGridView1.Rows[0].Cells[0];
    // // }
    return;
  }
  private m_nTemp = 0;
  private currentGeKou = "";
  private currentDaTouBi = ""; //当前单号的大头笔
  private m_strValidState = ""; //是否需要补码判断
  private modenewResponse = {}; //是否需要补码判断

  public async SetCodeCheck(strCode) {
    this.m_nTemp = 0;
    try {
      //查询三段码接口
      let request = {
        devMac: this.globalConfig.LocalMac,
        devType: "0",
        body: {
          autoMode: "14",
          wayBillNo: strCode,
          mac: this.globalConfig.LocalMacIPv4,
          extend1: "",
          extend2: "",
          //extend3 = (IsNeedVoiceLayer()) ? "1" : ""
          extend3: "",
        },
      };
      this.currentGeKou = "";
      this.currentDaTouBi = "";
      let start = dayjs().valueOf();
      var dwsQueryResponseNew = modeNew(JSON.stringify(request));
      let end = dayjs().valueOf();
      if (dwsQueryResponseNew.respcode != "000") {
        try {
          playFailSound();
        } catch (Exception) {
          //SetErrorMessage?.ExecuteAsync("失败提示音不存在");
          this.errormessage = "失败提示音不存在";
        }

        //SetErrorMessage?.ExecuteAsync($"S:{dwsQueryResponseNew.respMessage}");
        //SetScanAreaTextError.ExecuteAsync(strCode, $"{dwsQueryResponseNew.respMessage}");
        this.errormessage = dwsQueryResponseNew.respMessage;
        // // tbx_scanArea.Text = strCode;
        LogHelper.WriteLog(
          "【六面扫】三段码接口返回失败：" + dwsQueryResponseNew.respMessage
        );
        return false;
      } else {
        // // currentDestOrgCode = string.IsNullOrEmpty(dwsQueryResponseNew.data?.DEST_ORG)
        // //     ? ""
        // //     : dwsQueryResponseNew.data?.DEST_ORG;
        this.modenewResponse[strCode] = dwsQueryResponseNew.data
        this.currentDaTouBi =
          dwsQueryResponseNew.data?.da_TOU_BI == null
            ? ""
            : dwsQueryResponseNew.data?.da_TOU_BI;
        LogHelper.WriteLog(
          "【六面扫】三段码接口返回大头比为：" + this.currentDaTouBi
        );
        this.threeCode = this.currentDaTouBi;

        if ( dwsQueryResponseNew.data?.extend5 == null || dwsQueryResponseNew.data.extend5 == "") {
          this.extend5ThreeCode = "0";
        } else {
          this.extend5ThreeCode = dwsQueryResponseNew.data.extend5;
        }
        if (
          !this.IsNullorEmptyorUndefined(dwsQueryResponseNew.data?.da_TOU_BI) &&
          dwsQueryResponseNew.data.da_TOU_BI.startsWith("-")
        ) {
          if (dwsQueryResponseNew.data.da_TOU_BI.startsWith("-10")) {
            this.m_strValidState = "2";
            this.errormessage =  InterceptUtils.formatErrorMessage(strCode, dwsQueryResponseNew?.data.da_TOU_BI, dwsQueryResponseNew.respMessage);
            // m_nTemp = 1;
            try {
              playWantedPackSound(dwsQueryResponseNew.data.da_TOU_BI);
            } catch (Exception) {
              //this.errormessage = "失败提示音不存在";
            }
          } else {
            this.m_strValidState = "1";
          }
        } else {
          this.m_strValidState = "1";
        }

        if (dwsQueryResponseNew.data?.extend1 == "1") {
          let bIsDisplsy = false;
          if (
            dwsQueryResponseNew.data?.lattice_NO == "" ||
            dwsQueryResponseNew.data?.lattice_NO == null
          ) {
            //无异常或者此件为通缉件时优先显示异常信息和通缉件提示
            if (!this.isExceptionStatus && this.m_nTemp != 1) {
              this.m_strValidState = "3";
              this.errormessage =
                "无格口号 " +
                dwsQueryResponseNew.data?.da_TOU_BI +
                " " +
                dwsQueryResponseNew.data.waybill_NO;
              this.noLittleNum++;
              ScanforSixScanModule.setNoLittleNoLabel(this.noLittleNum);
              playLayerVioce("7");
              if (typeof VoiceLayerHelper !== "undefined") {
                VoiceLayerHelper.onPlaySoundFloor("7");
              }
            }

            bIsDisplsy = true;
            //LogHelper.WriteLog(this.errormessage);
            dwsQueryResponseNew.data.lattice_NO = "153";
          } else {
            this.currentGeKou = this.IsNullorEmptyorUndefined(
              dwsQueryResponseNew.data.lattice_NO
            )
              ? ""
              : dwsQueryResponseNew.data.lattice_NO;

            LogHelper.WriteLog(
              "【六面扫】三段码接口返回格口号为：" + this.currentGeKou
            );
            this.latticeNo = this.currentGeKou;
          }

          if (end - start <= 400) {
            if (!bIsDisplsy) {
              //SetErrorMessage?.ExecuteAsync("格口号：" + dwsQueryResponseNew.data?.LATTICE_NO);
              this.errormessage =
                "格口号：" + dwsQueryResponseNew.data?.lattice_NO;
              this.littleNum++;
              // LittleNoLabel.Text = littleNum.ToString();
              ScanforSixScanModule.setLittleNoLabel(this.littleNum);
            }

            //给底层发格口信息
            if (!this.isExceptionStatus) {
              if (
                dwsQueryResponseNew.data?.extend5 == null ||
                dwsQueryResponseNew.data.extend5 == ""
              ) {
                dwsQueryResponseNew.data.extend5 = "0";
              }
              //给底层发格口信息
              // HKSocket.SynSendDataCallBack(SendDataType.PortData,
              //     dwsQueryResponseNew.data?.WAYBILL_NO + "|" + dwsQueryResponseNew.data?.LATTICE_NO + "|" + dwsQueryResponseNew.data.EXTEND5);
              obj_DWS_Core.hKSocketSynSendDataCallBack(
                SendDataType.PortData,
                dwsQueryResponseNew.data?.waybill_NO +
                  "|" +
                  dwsQueryResponseNew.data?.lattice_NO +
                  "|" +
                  dwsQueryResponseNew.data.extend5
              );
            }
          } else {
            //非异常状态下且是DWS相关设备时给底层发格口信息
            if (
              !this.isExceptionStatus &&
              (this.globalConfig.CurrentDeviceType == 2 ||
                this.globalConfig.CurrentDeviceType == 7 ||
                this.globalConfig.CurrentDeviceType == 8)
            ) {
              this.errormessage =
                "无格口 " +
                dwsQueryResponseNew.data.da_TOU_BI +
                " " +
                dwsQueryResponseNew.data.waybill_NO +
                "请求格口超时(>400ms)-- " +
                (end - start) +
                "ms" +
                dwsQueryResponseNew.data.da_TOU_BI +
                " " +
                dwsQueryResponseNew.data.lattice_NO;
              this.overTimeNum++;
              // overTimeLabel.Text = overTimeNum.ToString();
              ScanforSixScanModule.setOverTimeLabel(this.overTimeNum);
              LogHelper.WriteLog(
                "请求格口超时(>400ms)-- " +
                  (end - start) +
                  "ms" +
                  dwsQueryResponseNew.data.da_TOU_BI +
                  " " +
                  dwsQueryResponseNew.data.lattice_NO
              );
              dwsQueryResponseNew.data.lattice_NO = "0";
              if (
                dwsQueryResponseNew.data?.extend5 == null ||
                dwsQueryResponseNew.data?.extend5 == ""
              ) {
                dwsQueryResponseNew.data.extend5 = "0";
              }
              // HKSocket.SynSendDataCallBack(SendDataType.PortData,
              //     dwsQueryResponseNew.data?.WAYBILL_NO + "|" + dwsQueryResponseNew.data?.LATTICE_NO + "|" + dwsQueryResponseNew.data?.EXTEND5);
              obj_DWS_Core.hKSocketSynSendDataCallBack(
                SendDataType.PortData,
                dwsQueryResponseNew.data.waybill_NO +
                  "|" +
                  dwsQueryResponseNew.data.lattice_NO +
                  "|" +
                  dwsQueryResponseNew.data.extend5
              );
              LogHelper.WriteLog(
                "三段码网关返回超时(默认400ms)：" + (end - start)
              );
            }
          }
        }

        if (this.m_bNeedSuppleCode) {
          if (
            this.m_strValidState == "1" ||
            (dwsQueryResponseNew.data?.extend1 == "1" &&
              this.m_strValidState == "3")
          ) {
            // Thread.Sleep(30);
            await this.sleep(30);
            LogHelper.WriteLog("【六面扫】需要补码，包裹准入code = " + strCode);
            // HKSocket.SynSendDataCallBack(SendDataType.SuppleCode, strCode);
            obj_DWS_Core.hKSocketSynSendDataCallBack(
              SendDataType.SuppleCode,
              strCode
            );
            this.m_bNeedSuppleCode = false;
            await this.sleep(100);

            // Thread.Sleep(100);
          } else {
            return false;
          }
        }

        //自己取格口的时候
        if (dwsQueryResponseNew.data?.extend1 == "1") {
          if (this.m_strValidState == "2") {
            LogHelper.WriteLog(
              "【六面扫】业务网关取格口，通知海康让plc停  通知代码已注释! and m_strValidState = " +
                this.m_strValidState
            );
            // HKSocket.SynSendDataCallBack(SendDataType.CodeValid, m_strValidState);
          } else if (this.m_strValidState == "1") {
            LogHelper.WriteLog(
              "【六面扫】业务网关取格口，通知海康让plc走and m_strValidState = " +
                this.m_strValidState
            );
            // HKSocket.SynSendDataCallBack(SendDataType.CodeValid, this.m_strValidState);
            obj_DWS_Core.hKSocketSynSendDataCallBack(
              SendDataType.CodeValid,
              this.m_strValidState
            );
          }
        }

        if (this.m_strValidState == "1" || this.m_strValidState == "3") {
          return true;
        } else {
          return true;
        }
      }
    } catch (ex) {
      LogHelper.WriteLog(
        "ScanForOutbound_Getoff " + "SetCodeCheck crash! " + ex
      );
    }
    return false;
  }
  private sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time));
  }
  private currentRowChanged(element) {
    ScanforSixScanModule.setTrueThingCode(element.strCode);
  }
  //字符串为null、空、未定义判断
  private IsNullorEmptyorUndefined(data) {
    if (data == null || data == undefined || data == "") {
      return true;
    } else {
      return false;
    }
  }
  //获得焦点，选中文本
  private getInputFocus(event): void {
    event.currentTarget.select();
  }
  //更新设备状态数据
  public getdevicestatecallback(datas): void {
    console.log("设备状态");
    console.log(datas);
    this.deviceItems = [];
    this.deviceItems = datas;
    console.log(this.deviceItems);
  }
  public index = 1;
  //更新数据列表的数据
  public datahistorycallback(data) {
    console.log(data);
    console.log("C#列表回传方法");
    var index = data.Value;
    this.showList = [];
    for (let _index = 0; _index < data.Key.length; _index++) {
      var element = data.Key[_index];
      this.showList.push({
        index: index,
        code: element.strCode,
        ScanTime: element.ScanTime,
        Info: element.UploadStateName,
      });
      index--;
    }
  }
  //错误消息回调显示方法
  public errormsgcallback(data) {
    this.errormessage = data;
  }
  //统计数据回显
  public statisticaldatacallback(data) {
    console.log("统计数据回显");
    console.log(data);
    data.forEach((element) => {
      console.log(element);
      if (element.Key == "totalScanCount") {
        this.statisticalList[0].value = element.Value;
        console.log("totalScanCount:" + element.Key + "|" + element.Value);
      }

       if (element.Key == "piecesCountInCar") {
         this.statisticalList[1].value = element.Value;
         console.log("piecesCountInCar:" + element.Key + "|" + element.Value);
       }
       if (element.Key == "totalWeight") {
         this.statisticalList[2].value = element.Value;
         console.log("totalWeight:" + element.Key + "|" + element.Value);
       }
    });

    console.log(this.statisticalList);
  }

  //是否启用新的界面显示，add by klm 2024/11/4
  public setnewcount(data)
  {
    debugger;
    ScanforSixScanModule.setSixScanState(data)
  }
  public msg = "";
  private config = config;
  private statisticalList = [];
  public currentrow = null;
  public showList = [];
  //存储单号跟格口三段码
  public latticeThreeCodeList = [];

  public ytoCode = "";
  private ytocodeget() {
    //由于六面扫没有扫描框输入的内容，所以不进行处理扫描区输入的数据
  }
  public callbackmodel = {};

  public selectElementContents(el) {
    console.log("|FUNC|selectElementContents");
    //失去焦点，获取焦点
    el.blur();
    el.focus();
  }
  private deviceItems: deviceItem[] = [];
  private errormessage = "";
  private currentRow = null;
  private tableshow = true;
}
